import React from 'react'
import SharedVisitFilterModal from '../common/SharedVisitFilterModal.jsx'
import { VISIT_FILTER_KEY } from '../../util/visitFilters'

const defaultVisitFilters = {
  SAID: '',
  memberNo: '',
  patientName: '',
  monthYear: '',
  recentDays: '42',
}

const VisitFilterModal = (props) => (
  <SharedVisitFilterModal
    {...props}
    storageKey={VISIT_FILTER_KEY}
    title="Filter Visits"
    defaultFilters={defaultVisitFilters}
    showActiveCriterionHelper={false}
  />
)

export default VisitFilterModal
